import {Order} from 'coreStore/data/orders/types';

import {IBaseFetchOptions, IBaseParameters, IBaseResponse, IEndpointsMap} from '../ICustomApiConfig';

export const endpointsMap: IEndpointsMap = {
	GET_ORDER: {
		path: 'orders/{c_orderNo}',
		method: 'GET'
	}
};

export interface IGetOrderByEmailOptions extends IBaseFetchOptions {
	pathParameters: {
		c_orderNo: string;
	};
	parameters: IBaseParameters & {
		c_email?: string;
	};
}

export interface IGetOrderByZipCodeOptions extends IBaseFetchOptions {
	pathParameters: {
		c_orderNo: string;
	};
	parameters: IBaseParameters & {
		c_zipCode: string;
	};
}

export interface IGetOrderResponse extends IBaseResponse {
	order: Order;
}
